/** `submitChecklist` off the dashboard response: per-code verdict, "Y" (complete) or "N" (incomplete). */
export type StatusByCode = Readonly<Record<string, string>> | undefined;

/** The verdict that flags a section's warning icon. */
export const CHECKLIST_INCOMPLETE = "N";

export const CHECKLIST_CODES = {
  driver: { person: "STP6DR", income: "STP6DRINC", bank: "STP6DRBNK", residence: "STP6DRRES" },
  secondSigner: { person: "STP6SS", income: "STP6SSINC", bank: "STP6SSBNK", residence: "STP6SSRES" },
  vehicle: "STEP6VEH",
  obp: "STP6OTBDPS",
} as const;

export interface SignerChecklist {
  readonly person: boolean;
  readonly income: boolean;
  readonly bank: boolean;
  readonly residence: boolean;
  readonly any: boolean;
}

// True only when a code is explicitly "N"; an absent code carries no verdict.
/**
 *
 * @param statusByCode
 * @param {...any} codes
 */
export function isChecklistIncomplete(statusByCode: StatusByCode, ...codes: string[]): boolean {
  return codes.some((code) => statusByCode?.[code] === CHECKLIST_INCOMPLETE);
}

/**
 *
 * @param statusByCode
 * @param personPath
 */
export function signerChecklist(statusByCode: StatusByCode, personPath: "driver" | "secondSigner"): SignerChecklist {
  const codes = CHECKLIST_CODES[personPath];
  const person = isChecklistIncomplete(statusByCode, codes.person);
  const income = isChecklistIncomplete(statusByCode, codes.income);
  const bank = isChecklistIncomplete(statusByCode, codes.bank);
  const residence = isChecklistIncomplete(statusByCode, codes.residence);
  return { person, income, bank, residence, any: person || income || bank || residence };
}
